// @flow
import React, { useState } from 'react';
import Modal from 'react-modal';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ShareForm } from 'components/organisms/shareForm';
import { useViewport } from 'components/templates/viewportProvider';
import chevronUpIcon from 'assets/images/upb.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  callPostLeadAPI?: boolean,
};

export const ShareModal = (props: Props) => {
  const { isMobile } = useViewport();
  const [showToast, setShowToast] = useState(false);
  const { isOpen, onClosePress, callPostLeadAPI = false } = props;

  const onClose = () => {
    onClosePress();
  };

  const copyLinkToClipboard = () => {
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const pageUrl = `${window.location.origin}${window.location.pathname}`;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`share-overlay-content`}
      // TODO: for banners
      shouldCloseOnOverlayClick={false}
      hideModalContentWhileAnimating={true}
    >
      <div className={'share-modal'}>
        {/*TODO Just for phase 1*/}
        {/*<h3>Share this page via SMS or Email</h3>*/}
        <h3>Share this page via Email</h3>
        <div className={'copy-link-container'}>
          <span>{pageUrl}</span>
          <CopyToClipboard text={pageUrl} onCopy={copyLinkToClipboard}>
            <a href={'#'} onClick={copyLinkToClipboard}>
              Copy
            </a>
          </CopyToClipboard>
          {showToast && <p>Copied to clipboard</p>}
        </div>
        <ShareForm
          onSubmitSuccess={onClose}
          shareLink={pageUrl}
          isMobile={isMobile}
          callPostLeadAPI={callPostLeadAPI}
        />
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronUpIcon} alt={'icon'} />
        </a>
      </div>
    </Modal>
  );
};
